module.exports = __webpack_public_path__ + "img/index_sence_img5.9a85dc91.png";